import { cn } from "@/lib/utils";
import { ArrowUp } from "lucide-react";
import { MutableRefObject, useState, useEffect } from "react";
import { Button } from "./ui/button";

export function BackToTopButton({ scrollContainerRef, visibleThresholdRef }: { scrollContainerRef: MutableRefObject<HTMLElement>, visibleThresholdRef: MutableRefObject<HTMLElement> }) {
    const [visible, setVisible] = useState(false);
    const [scrollbarWidth, setScrollbarWidth] = useState(0);


    useEffect(() => {
        if (scrollContainerRef.current) {
            setScrollbarWidth(scrollContainerRef.current.offsetWidth - scrollContainerRef.current.clientWidth);
        }
    }, [scrollContainerRef]);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        function scrollHandler() {
            const bounds = visibleThresholdRef.current.getBoundingClientRect();

            if (bounds.top < 0 && !visible) setVisible(true);
            else if (bounds.top > 0 && visible) setVisible(false);
        }
        scrollContainer.addEventListener("scroll", scrollHandler);
        return () => {
            scrollContainer.removeEventListener("scroll", scrollHandler);
        };
    }, [scrollContainerRef, visible, visibleThresholdRef]);

    return <Button
        className={cn(
            "absolute bottom-2",
            !visible && "hidden"
        )}
        style={{ right: `calc(0.5rem + ${scrollbarWidth}px)` }}
        onClick={() => {
            scrollContainerRef.current.scrollTo({ behavior: "smooth", top: 0 });
        }}>
        <ArrowUp />
    </Button >;
}